import Slider from "../Slider/Slider"

const Home = () => {
  return (
    <>
      <Slider />
    </>
  )
}

export default Home